import React from "react";
import { useState } from "react";
import '../Styles/GroupSignUpForm.scss';
import { useNavigate } from "react-router-dom";
import Session from 'react-session-api';
import InputValidation from "../Helper/InputValidation";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

function GroupAccountForm({groupAccountInformation, setGroupAccountInformation, handleSubmit}) {

   const [showGroupPassword, setShowGroupPassword] = useState(false)
   const [showGroupConfirmPassword, setShowGroupConfirmPassword] = useState(false)
   // Account creation can lag for a few seconds with nothing on screen to show it's working.
   const [isSubmitting, setIsSubmitting] = useState(false)
   const [invalidGroupName, setInvalidGroupName] = useState(false)
   const [invalidGroupAdmin, setInvalidGroupAdmin] = useState(false)
   const [invalidGroupEmail, setInvalidGroupEmail] = useState(false)
   const [invalidGroupPassword, setInvalidGroupPassword] = useState(false)
   const [invalidGroupPasswordFormat, setInvalidGroupPasswordFormat] = useState(false)
   const [invalidGroupPasswordConfirm, setInvalidGroupPasswordConfirm] = useState(false)
   const [invalidPasswordMatch, setInvalidPasswordMatch] = useState(false)
   const [invalidAddressLine1, setInvalidAddressLine1] = useState(false)
   const [invalidCity, setInvalidCity] = useState(false)
   const [invalidState, setInvalidState] = useState(false)
   const [emptyCountryError, setEmptyCountryError] = useState(false)
   const [invalidZip, setInvalidZip] = useState(false)
   const [invalidZipFormat, setInvalidZipFormat] = useState(false)

   async function ValidateGroupInfo(){
      console.log("We are in Validation Function")
      let isError = false
      // Group name must exist
      if(groupAccountInformation.groupName === ""){
         isError = true
         setInvalidGroupName(true)
      }
      // Group admin must exist
      if(groupAccountInformation.groupAdmin === ""){
         isError = true
         setInvalidGroupAdmin(true)
      }
      // Group email must exist
      if(groupAccountInformation.groupEmail === ""){
         isError = true
         setInvalidGroupEmail(true)
      }
      // Group password must exist
      if(groupAccountInformation.groupPassword === ""){
         isError = true
         setInvalidGroupPassword(true)
      }
      if(groupAccountInformation.groupPassword != ""){
          const condition = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/
          if(condition.test(groupAccountInformation.groupPassword) === false){
            setInvalidGroupPasswordFormat(true)
            isError = true
          }
      }
      // Group confirm password must exist
      if(groupAccountInformation.groupConfirmPassword === ""){
         isError = true
         setInvalidGroupPasswordConfirm(true)
      }
      // Group confirm password must both exist and match each other
      if(groupAccountInformation.groupPassword != "" && groupAccountInformation.groupConfirmPassword != "" && groupAccountInformation.groupPassword != groupAccountInformation.groupConfirmPassword){
         isError = true
         setInvalidPasswordMatch(true)
      }
      // Address line one must exist
      if(groupAccountInformation.groupAddressOne === ""){
         isError = true
         setInvalidAddressLine1(true)
      }
      // City must exist
      if(groupAccountInformation.groupCity === ""){
         isError = true
         setInvalidCity(true)
      }
      // State must exist
      if(groupAccountInformation.groupState === ""){
         isError = true
         setInvalidState(true)
      } 
      // Zip must exist
      if(groupAccountInformation.groupZip === ""){
         isError = true
         setInvalidZip(true)
      }
      if(groupAccountInformation.groupZip != ""){
         const condition = /^(?!00000)\d{5}(?:[-\s](?!0000)\d{4})?$/
         if (condition.test(groupAccountInformation.groupZip) === false)
         {
            setInvalidZipFormat(true)
            isError = true
         }
      }
      if(isError === false){
         setIsSubmitting(true)
         try {
            await handleSubmit()
         } finally {
            setIsSubmitting(false)
         }
      }
   }

   return (
      <div>
         <div className="groupSignUpContent">

            <div className="groupSignUpContainer">
               <div className="groupSignUpHeading">
                  <h2>Create a New Group Account</h2>
               </div>

               <form>
                  <div className="groupInfo">
                     <div className="groupName">
                        {invalidGroupName === true &&
                           <div className="groupNameError">
                              * Group name is required
                           </div>
                        }
                        <label htmlFor="firstName">Group Name:*</label>
                        <input 
                        required id="firstName" 
                        type="text" 
                        name='groupName' 
                        value={groupAccountInformation.groupName} 
                        onChange={event => { 
                           setGroupAccountInformation({ ...groupAccountInformation, groupName: event.target.value })
                           setInvalidGroupName(false)
                        }} />
                     </div>

                     <div className="groupAdminName">
                      {invalidGroupAdmin === true &&
                           <div className="groupAdminError">
                              * Group admin name is required
                           </div>
                        }
                        <label htmlFor="lastName">Group Administrator Name:*</label>
                        <input 
                        required 
                        id="lastName" 
                        type="text" 
                        name="groupAdminName" 
                        value={groupAccountInformation.groupAdmin} 
                        onChange={event => {
                           setGroupAccountInformation({ ...groupAccountInformation, groupAdmin: event.target.value })
                           setInvalidGroupAdmin(false)
                        }} />
                     </div>

                     <div className="groupEmail">
                        {invalidGroupEmail === true &&
                           <div className="groupEmailError">
                              * Group email is required
                           </div>
                        }
                        <label htmlFor="groupEmail">Group Email Address:*</label>
                        <input 
                        required 
                        id="firstName" 
                        type="text" name='groupEmail' 
                        value={groupAccountInformation.groupEmail} 
                        onChange={event => {
                           setGroupAccountInformation({ ...groupAccountInformation, groupEmail: event.target.value })
                           setInvalidGroupEmail(false)
                        }} />
                     </div>

                     <div className="groupPassword">
                        {invalidGroupPassword === true &&
                        <div className="groupPasswordError">
                           * Group password is required
                        </div>
                        }
                        {invalidPasswordMatch === true &&
                        <div className="groupPasswordMatchError">
                           * Passwords must match
                        </div>
                        }
                        {invalidGroupPasswordFormat === true &&
                        <div className="groupPasswordFormatError">
                           * Password does not conform to the below constraints
                        </div>
                        }
                        <label htmlFor="groupPassword">Create Group Password:*</label>
                        <div className="groupAccountPasswordWrapper">
                           <input
                           required
                           id="password"
                           type={showGroupPassword ? "text" : "password"}
                           name="groupPassword"
                           value={groupAccountInformation.groupPassword}
                           onChange={event => {
                              setGroupAccountInformation({ ...groupAccountInformation, groupPassword: event.target.value })
                              setInvalidGroupPassword(false)
                              setInvalidPasswordMatch(false)
                              setInvalidGroupPasswordFormat(false)
                           }} />
                           <button
                              type="button"
                              className="groupAccountPasswordToggle"
                              onClick={() => setShowGroupPassword(!showGroupPassword)}
                              aria-label={showGroupPassword ? "Hide password" : "Show password"}>
                              {showGroupPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                           </button>
                        </div>
                     </div>

                     <div className="groupPassword">
                        {invalidGroupPasswordConfirm === true &&
                        <div className="groupPasswordConfirmError">
                           * Please confirm password
                        </div>
                        }
                        <label htmlFor="groupConfirmPassword">Confirm Group Password:*</label>
                        <div className="groupAccountPasswordWrapper">
                           <input
                           required
                           type={showGroupConfirmPassword ? "text" : "password"}
                           name="groupConfirmPassword"
                           value={groupAccountInformation.groupConfirmPassword}
                           onChange={event => {
                              setGroupAccountInformation({ ...groupAccountInformation, groupConfirmPassword: event.target.value})
                              setInvalidGroupPasswordConfirm(false)
                           }} />
                           <button
                              type="button"
                              className="groupAccountPasswordToggle"
                              onClick={() => setShowGroupConfirmPassword(!showGroupConfirmPassword)}
                              aria-label={showGroupConfirmPassword ? "Hide password" : "Show password"}>
                              {showGroupConfirmPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                           </button>
                        </div>
                     </div>

                     <div className="disclaimerPSG">
                        <>Password must be: <br></br>
                           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- at least 8 characters long; contain one number; <br></br>
                           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- contain one symbol; contain one uppercase letter; <br></br>
                           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- contain one lowercase letter </>
                     </div>

                     <h2>Group Info</h2>

                     <div className="groupAddress1">
                        {invalidAddressLine1 === true &&
                        <div className="groupAddressLine1Error">
                           * Address is required
                        </div>
                        }
                        <label htmlFor="groupAddress1">Address Line 1:*</label>
                        <input 
                        required 
                        id="address1" 
                        type="text" 
                        name="groupAddress1" 
                        value={groupAccountInformation.groupAddressOne} 
                        onChange={event => {
                           setGroupAccountInformation({ ...groupAccountInformation, groupAddressOne: event.target.value })
                           setInvalidAddressLine1(false)
                        }} />
                     </div>

                     <div className="groupAddress2">
                        <label htmlFor="groupAddress2">Address Line 2</label>
                        <input id="address2" type="text" name="groupAddress2" value={groupAccountInformation.groupAddressTwo} onChange={event => setGroupAccountInformation({ ...groupAccountInformation, groupAddressTwo: event.target.value})} />
                     </div>

                     <div className="groupCity">
                        {invalidCity === true &&
                        <div className="groupCityError">
                           * City is required
                        </div>
                        }
                        <label htmlFor="groupCity">City:*</label>
                        <input 
                        required 
                        id="groupCity" 
                        type="text" 
                        name="groupCity" 
                        value={groupAccountInformation.groupCity} 
                        onChange={event => {
                           setGroupAccountInformation({ ...groupAccountInformation, groupCity: event.target.value})
                           setInvalidCity(false)
                        }} />
                     </div>

                     <div className="groupState">
                      {invalidState === true &&
                        <div className="groupStateError">
                           * State is required
                        </div>
                        }
                        <label htmlFor="groupState">State:*</label>
                        <select
                           value={groupAccountInformation.groupState}
                           defaultValue={groupAccountInformation.groupState}
                           onChange={event => {
                              setGroupAccountInformation({ ...groupAccountInformation, groupState: event.target.value})
                              setInvalidState(false)
                           }}
                           id="state"
                           name="state">
                           <option value="---">---</option>
                           <option value="Alabama">Alabama</option>
                           <option value="Alaska">Alaska</option>
                           <option value="Arizona">Arizona</option>
                           <option value="Arkansas">Arkansas</option>
                           <option value="California">California</option>
                           <option value="Colorado">Colorado</option>
                           <option value="Connecticut">Connecticut</option>
                           <option value="Delaware">Delaware</option>
                           <option value="District of Columbia">District of Columbia</option>
                           <option value="Florida">Florida</option>
                           <option value="Georgia">Georgia</option>
                           <option value="Guam">Guam</option>
                           <option value="Hawaii">Hawaii</option>
                           <option value="Idaho">Idaho</option>
                           <option value="Illinois">Illinois</option>
                           <option value="Indiana">Indiana</option>
                           <option value="Iowa">Iowa</option>
                           <option value="Kansas">Kansas</option>
                           <option value="Kentucky">Kentucky</option>
                           <option value="Louisiana">Louisiana</option>
                           <option value="Maine">Maine</option>
                           <option value="Maryland">Maryland</option>
                           <option value="Massachusetts">Massachusetts</option>
                           <option value="Michigan">Michigan</option>
                           <option value="Minnesota">Minnesota</option>
                           <option value="Mississippi">Mississippi</option>
                           <option value="Missouri">Missouri</option>
                           <option value="Montana">Montana</option>
                           <option value="Nebraska">Nebraska</option>
                           <option value="Nevada">Nevada</option>
                           <option value="New Hampshire">New Hampshire</option>
                           <option value="New Jersey">New Jersey</option>
                           <option value="New Mexico">New Mexico</option>
                           <option value="New York">New York</option>
                           <option value="North Carolina">North Carolina</option>
                           <option value="North Dakota">North Dakota</option>
                           <option value="Northern Marianas Islands">Northern Marianas Islands</option>
                           <option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option>
                           <option value="Oregon">Oregon</option>
                           <option value="Pennsylvania">Pennsylvania</option>
                           <option value="Puerto Rico">Puerto Rico</option>
                           <option value="Rhode Island">Rhode Island</option>
                           <option value="South Carolina">South Carolina</option>
                           <option value="South Dakota">South Dakota</option>
                           <option value="Tennessee">Tennessee</option>
                           <option value="Texas">Texas</option>
                           <option value="Utah">Utah</option>
                           <option value="Vermont">Vermont</option>
                           <option value="Virginia">Virginia</option>
                           <option value="Virgin Islands">Virgin Islands</option>
                           <option value="Washington">Washington</option>
                           <option value="West Virginia">West Virginia</option>
                           <option value="Wisconsin">Wisconsin</option>
                           <option value="Wyoming">Wyoming</option>
                        </select>
                     </div>

                     <div className="groupZip">
                        {invalidZip === true &&
                        <div className="groupZipError">
                           * Zip code is required
                        </div>
                        }
                        {invalidZipFormat === true &&
                        <div className="groupZipFormatError">
                           * Zip code must be formatted as such: 12345, 12345 6789, or 12345-6789
                        </div>
                        }
                        <label htmlFor="groupZip">Zip:*</label>
                        <input 
                        required 
                        id="groupZip" 
                        type="text" 
                        name="groupZip" 
                        value={groupAccountInformation.groupZip} 
                        maxLength={10} 
                        onChange={event => {
                           setGroupAccountInformation({ ...groupAccountInformation, groupZip: InputValidation.ValidateInputForPhoneAndZipCode(event.target.value)})
                           setInvalidZip(false)
                           setInvalidZipFormat(false)
                        }} />
                     </div>
                     <div className="createAccountContactInformationFieldsCountry">
                           {emptyCountryError === true &&
                              <div className="emptyCountry">
                                 * Country Is Required
                              </div>
                           }
                           <label for="state">Country </label>
                           <select
                              value={groupAccountInformation.country}
                              defaultValue={groupAccountInformation.country}
                              onChange={event => {
                                 setGroupAccountInformation({ ...groupAccountInformation, country: (event.target.value) })
                                 setEmptyCountryError(false)
                              }}
                              id="state"
                              name="state">
                              <option value="Select Country">Select Country</option>
                              <option value="Afghanistan">Afghanistan</option>
                              <option value="Albania">Albania</option>
                              <option value="Algeria">Algeria</option>
                              <option value="Andorra">Andorra</option>
                              <option value="Angola">Angola</option>
                              <option value="AntiguaAndBarbuda">Antigua and Barbuda</option>
                              <option value="Argentina">Argentina</option>
                              <option value="Armenia">Armenia</option>
                              <option value="Australia">Australia</option>
                              <option value="Austria">Austria</option>
                              <option value="Azerbaijan">Azerbaijan</option>
                              <option value="Bahamas">Bahamas</option>
                              <option value="Bahrain">Bahrain</option>
                              <option value="Bangladesh">Bangladesh</option>
                              <option value="Barbados">Barbados</option>
                              <option value="Belarus">Belarus</option>
                              <option value="Belgium">Belgium</option>
                              <option value="Belize">Belize</option>
                              <option value="Benin">Benin</option>
                              <option value="Bhutan">Bhutan</option>
                              <option value="Bolivia">Bolivia</option>
                              <option value="BosniaAndHerzegovina">Bosnia and Herzegovina</option>
                              <option value="Botswana">Botswana</option>
                              <option value="Brazil">Brazil</option>
                              <option value="BruneiDarussalam">Brunei Darussalam</option>
                              <option value="Bulgaria">Bulgaria</option>
                              <option value="BurkinaFaso">Burkina Faso</option>
                              <option value="Burundi">Burundi</option>
                              <option value="CaboVerde">Cabo Verde</option>
                              <option value="Cambodia">Cambodia</option>
                              <option value="Cameroon">Cameroon</option>
                              <option value="Canada">Canada</option>
                              <option value="CentralAfricanRepublic">Central African Republic</option>
                              <option value="Chad">Chad</option>
                              <option value="Chile">Chile</option>
                              <option value="China">China</option>
                              <option value="Colombia">Colombia</option>
                              <option value="Comoros">Comoros</option>
                              <option value="Congo">Congo</option>
                              <option value="CongoDemocraticRepublic">Congo, Democratic Republic of the</option>
                              <option value="CostaRica">Costa Rica</option>
                              <option value="Croatia">Croatia</option>
                              <option value="Cuba">Cuba</option>
                              <option value="Cyprus">Cyprus</option>
                              <option value="CzechRepublic">Czech Republic</option>
                              <option value="Denmark">Denmark</option>
                              <option value="Djibouti">Djibouti</option>
                              <option value="Dominica">Dominica</option>
                              <option value="DominicanRepublic">Dominican Republic</option>
                              <option value="Ecuador">Ecuador</option>
                              <option value="Egypt">Egypt</option>
                              <option value="ElSalvador">El Salvador</option>
                              <option value="EquatorialGuinea">Equatorial Guinea</option>
                              <option value="Eritrea">Eritrea</option>
                              <option value="Estonia">Estonia</option>
                              <option value="Eswatini">Eswatini</option>
                              <option value="Ethiopia">Ethiopia</option>
                              <option value="Fiji">Fiji</option>
                              <option value="Finland">Finland</option>
                              <option value="France">France</option>
                              <option value="Gabon">Gabon</option>
                              <option value="Gambia">Gambia</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Germany">Germany</option>
                              <option value="Ghana">Ghana</option>
                              <option value="Greece">Greece</option>
                              <option value="Grenada">Grenada</option>
                              <option value="Guatemala">Guatemala</option>
                              <option value="Guinea">Guinea</option>
                              <option value="GuineaBissau">Guinea-Bissau</option>
                              <option value="Guyana">Guyana</option>
                              <option value="Haiti">Haiti</option>
                              <option value="Honduras">Honduras</option>
                              <option value="Hungary">Hungary</option>
                              <option value="Iceland">Iceland</option>
                              <option value="India">India</option>
                              <option value="Indonesia">Indonesia</option>
                              <option value="Iran">Iran</option>
                              <option value="Iraq">Iraq</option>
                              <option value="Ireland">Ireland</option>
                              <option value="Israel">Israel</option>
                              <option value="Italy">Italy</option>
                              <option value="Jamaica">Jamaica</option>
                              <option value="Japan">Japan</option>
                              <option value="Jordan">Jordan</option>
                              <option value="Kazakhstan">Kazakhstan</option>
                              <option value="Kenya">Kenya</option>
                              <option value="Kiribati">Kiribati</option>
                              <option value="KoreaDemocraticPeopleRepublic">Korea, Democratic People's Republic of</option>
                              <option value="KoreaRepublic">Korea, Republic of</option>
                              <option value="Kuwait">Kuwait</option>
                              <option value="Kyrgyzstan">Kyrgyzstan</option>
                              <option value="LaoPeoplesDemocraticRepublic">Lao People's Democratic Republic</option>
                              <option value="Latvia">Latvia</option>
                              <option value="Lebanon">Lebanon</option>
                              <option value="Lesotho">Lesotho</option>
                              <option value="Liberia">Liberia</option>
                              <option value="Libya">Libya</option>
                              <option value="Liechtenstein">Liechtenstein</option>
                              <option value="Lithuania">Lithuania</option>
                              <option value="Luxembourg">Luxembourg</option>
                              <option value="Madagascar">Madagascar</option>
                              <option value="Malawi">Malawi</option>
                              <option value="Malaysia">Malaysia</option>
                              <option value="Maldives">Maldives</option>
                              <option value="Mali">Mali</option>
                              <option value="Malta">Malta</option>
                              <option value="MarshallIslands">Marshall Islands</option>
                              <option value="Mauritania">Mauritania</option>
                              <option value="Mauritius">Mauritius</option>
                              <option value="Mexico">Mexico</option>
                              <option value="Micronesia">Micronesia</option>
                              <option value="Moldova">Moldova</option>
                              <option value="Monaco">Monaco</option>
                              <option value="Mongolia">Mongolia</option>
                              <option value="Montenegro">Montenegro</option>
                              <option value="Morocco">Morocco</option>
                              <option value="Mozambique">Mozambique</option>
                              <option value="Myanmar">Myanmar</option>
                              <option value="Namibia">Namibia</option>
                              <option value="Nauru">Nauru</option>
                              <option value="Nepal">Nepal</option>
                              <option value="Netherlands">Netherlands</option>
                              <option value="NewZealand">New Zealand</option>
                              <option value="Nicaragua">Nicaragua</option>
                              <option value="Niger">Niger</option>
                              <option value="Nigeria">Nigeria</option>
                              <option value="NorthMacedonia">North Macedonia</option>
                              <option value="Norway">Norway</option>
                              <option value="Oman">Oman</option>
                              <option value="Pakistan">Pakistan</option>
                              <option value="Palau">Palau</option>
                              <option value="Panama">Panama</option>
                              <option value="PapuaNewGuinea">Papua New Guinea</option>
                              <option value="Paraguay">Paraguay</option>
                              <option value="Peru">Peru</option>
                              <option value="Philippines">Philippines</option>
                              <option value="Poland">Poland</option>
                              <option value="Portugal">Portugal</option>
                              <option value="Qatar">Qatar</option>
                              <option value="Romania">Romania</option>
                              <option value="RussianFederation">Russian Federation</option>
                              <option value="Rwanda">Rwanda</option>
                              <option value="SaintKittsAndNevis">Saint Kitts and Nevis</option>
                              <option value="SaintLucia">Saint Lucia</option>
                              <option value="SaintVincentAndTheGrenadines">Saint Vincent and the Grenadines</option>
                              <option value="Samoa">Samoa</option>
                              <option value="SanMarino">San Marino</option>
                              <option value="SaoTomeAndPrincipe">Sao Tome and Principe</option>
                              <option value="SaudiArabia">Saudi Arabia</option>
                              <option value="Senegal">Senegal</option>
                              <option value="Serbia">Serbia</option>
                              <option value="Seychelles">Seychelles</option>
                              <option value="SierraLeone">Sierra Leone</option>
                              <option value="Singapore">Singapore</option>
                              <option value="Slovakia">Slovakia</option>
                              <option value="Slovenia">Slovenia</option>
                              <option value="SolomonIslands">Solomon Islands</option>
                              <option value="Somalia">Somalia</option>
                              <option value="SouthAfrica">South Africa</option>
                              <option value="SouthSudan">South Sudan</option>
                              <option value="Spain">Spain</option>
                              <option value="SriLanka">Sri Lanka</option>
                              <option value="Sudan">Sudan</option>
                              <option value="Suriname">Suriname</option>
                              <option value="Sweden">Sweden</option>
                              <option value="Switzerland">Switzerland</option>
                              <option value="Syria">Syria</option>
                              <option value="Taiwan">Taiwan</option>
                              <option value="Tajikistan">Tajikistan</option>
                              <option value="Tanzania">Tanzania</option>
                              <option value="Thailand">Thailand</option>
                              <option value="TimorLeste">Timor-Leste</option>
                              <option value="Togo">Togo</option>
                              <option value="Tonga">Tonga</option>
                              <option value="TrinidadAndTobago">Trinidad and Tobago</option>
                              <option value="Tunisia">Tunisia</option>
                              <option value="Turkey">Turkey</option>
                              <option value="Turkmenistan">Turkmenistan</option>
                              <option value="Tuvalu">Tuvalu</option>
                              <option value="Uganda">Uganda</option>
                              <option value="Ukraine">Ukraine</option>
                              <option value="UnitedArabEmirates">United Arab Emirates</option>
                              <option value="UnitedKingdom">United Kingdom</option>
                              <option value="UnitedStates">United States</option>
                              <option value="Uruguay">Uruguay</option>
                              <option value="Uzbekistan">Uzbekistan</option>
                              <option value="Vanuatu">Vanuatu</option>
                              <option value="Venezuela">Venezuela</option>
                              <option value="Vietnam">Vietnam</option>
                              <option value="Yemen">Yemen</option>
                              <option value="Zambia">Zambia</option>
                              <option value="Zimbabwe">Zimbabwe</option>
                           </select>
                        </div>

                     <div className="groupSignUpDisclaimer">
                        * Fields are required
                     </div>
                  </div>
               </form>
               {(invalidGroupName === true            || invalidGroupAdmin === true    ||
                 invalidGroupEmail === true           || invalidGroupPassword === true ||
                 invalidGroupPasswordConfirm === true || invalidAddressLine1 === true  ||
                 invalidCity === true                 || invalidState === true         ||
                 invalidZip === true                  || invalidZipFormat === true     ||
                 invalidPasswordMatch === true) &&
                  <div className="groupSignUpError">
                     Please correct the following error(s)
                  </div>

               }
                <div className="groupSubmitButton">
                        <button disabled={isSubmitting} onClick={() => ValidateGroupInfo()}>
                           {isSubmitting && <span className="authSpinner" aria-hidden="true"></span>}
                           {isSubmitting ? "Creating Account..." : "Create Group Account"}
                        </button>
               </div>
            </div>
         </div>
      </div>
   )
}
export default GroupAccountForm;

